<!-- 工作台 -->
<template>
  <div v-loading="loading">
    <div class="form-main">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="车主名称"
              prop="CId"
            >
              <el-select
                style="width: 100%"
                v-model="formData.CId"
                filterable
                clearable
                remote
                reserve-keyword
                :remote-method="searchCarOwners"
                v-select-scroll-more="searchCarOwnersLoad"
                @clear="clearOwners"
                @change="carOwnerChange($event)"
                @visible-change="carOwnerVisibleChange($event)"
                placeholder="选择车主"
              >
                <el-option
                  v-for="item in carOwners"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                  :data-msg="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="手机号"
              prop="PhoneNum"
            >
              <el-input
                v-model.trim="formData.PhoneNum"
                :maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item
              label="选择车辆"
              prop="CarbarnId"
              style="width: 100%"
            >
              <el-select
                style="width: 100%"
                filterable
                clearable
                v-model="formData.CarbarnId"
              >
                <el-option
                  v-for="item in carbarns"
                  :key="item.CarId"
                  :label="item.CarDesc"
                  :value="item.CarId"
                  :data-msg="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="预约类型"
              prop="reservationTypes"
            >
              <el-select
                v-model="formData.ReservationType"
                style="width: 100%"
              >
                <el-option
                  v-for="item in reservationTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item
              label="费用"
              prop="Fee"
            >
              <el-input
                type="number"
                v-model.trim="formData.Fee"
                :maxlength="6"
                placeholder="上门检修与公路救援必须填写费用"
              ></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="预约日期"
              prop="RDate"
            >
              <el-date-picker
                style="width: 100%"
                v-model="formData.RDate"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="时间"
              prop="RTime"
            >
              <el-time-picker
                style="width: 100%"
                is-range
                v-model="formData.RTime"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                format="HH:mm"
                value-format="HH:mm"
              >
                >
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item
              label="备注"
              prop="Remark"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="备注"
                v-model="formData.Remark"
                :maxlength="100"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div class="dialog-footer">
        <el-button
          size="small"
          class="btn-primary"
          @click="submitForm"
        >提交</el-button>
        <el-button size="small" @click="cancel()">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    let checkPhone = this.$util.checkPhone;
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      loading: false,
      searchLoading: false,
      isReadOnly: false,
      canRequest: true,
      reservationTypes: [
        {
          value: 0,
          label: "到店检修"
        },
        // 功能待完善，暂时注释
        // {
        //   value: 1,
        //   label: "上门检修"
        // },
        // {
        //   value: 2,
        //   label: "公路救援"
        // }
      ],
      carOwners: [],
      carbarns: [],
      formData: {
        EntpId: userMsg.EntpId,
        Operator: userMsg.EmployeeId,
        CId: "",
        PhoneNum: "",
        CarbarnId: "",
        Remark: "",
        RDate: "",
        RTime: "",
        ReservationType: 0,
        Fee: "",
        Name: ""
      },
      rules: {
        CId: [
          {
            required: true,
            message: "该项必填",
            trigger: "change"
          }
        ],
        PhoneNum: [
          {
            required: true,
            message: "该项必填",
            trigger: "change"
          },
          { validator: checkPhone, trigger: "change" }
        ],
        CarbarnId: [
          {
            required: true,
            message: "该项必填",
            trigger: "change"
          }
        ],
        RDate: [
          {
            required: true,
            message: "该项必填",
            trigger: "change"
          }
        ],
        RTime: [
          {
            required: true,
            message: "该项必填",
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 用于车主名称列表，分页搜索
      carOwnerForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: '',
      },
    };
  },
  mounted() {
    this.getcarOwner();
  },
  methods: {
    getcarOwner(key, obj) {
      let that = this;
      that.searchLoading = true;
      that.carbarns = []
      if (![undefined].includes(key)) {
        that.carOwnerForm.Page = 1
        that.carOwnerForm.stopLoad = false
        that.carOwnerForm.key = key
        that.carOwners = []
      }
      if (that.carOwnerForm.stopLoad) return
      that.$util
        .searchCarOwners(
          that.carOwnerForm.key,
          that.carOwnerForm.Page,
          that.carOwnerForm.Limit
        )
        .then(data => {
           if(!data){
             that.searchLoading = false;
             return;
           }
          that.searchLoading = false; 
          that.carOwnerForm.stopLoad = data.length < that.carOwnerForm.Limit
          that.carOwners = [
            ...that.carOwners,
            ...data
          ]
          if (obj.type === 'isEdit') {
            that.formData.CId = "";
            // 不知道为啥直接修改表单中Name没有同步更新，这里使用异步处理
            setTimeout(() => this.carOwnerChange(obj.value), 0);
          }
          that.searchLoading = false;
        })
        .catch(err => {
          that.searchLoading = false;
        });
    },
    carOwnerVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.carOwners.length == 0) that.getcarOwner('');
      }
    },
    clearOwners() {
      this.carOwners = [];
      this.getcarOwner('');
    },
    carOwnerChange(val) {
      let that = this;
      that.carbarns = [];
      that.formData.CarbarnId = "";
      that.formData.PhoneNum = "";
      if (val) {
        for (const item of that.carOwners) {
          if (item.Id == val) {
            that.formData.CId = val;
            that.formData.Name = item.Name;
            that.formData.PhoneNum = item.PhoneNum;
            that.getCars(val);
            that.$emit("chooseItem", that.formData);
            return;
          }
        }
      } else {
        that.$emit("chooseItem", that.formData);
      }
    },
    searchCarOwners(key) {
      this.getcarOwner(key);
    },
    searchCarOwnersLoad() {
      this.carOwnerForm.Page += 1
      this.searchCarOwners()
    },
    getCars(carowerId) {
      let that = this;
      that.carbarns = [];
      that.$util
        .axiosGet({
          url: "/api/CustomerManagement/GetCarOwnerCars",
          data: {
            cId: carowerId,
            withCarNum: true
          },
          hideLoading: true
        })
        .then(res => {
          that.carbarns = res.data;
        });
    },
    // 提交表单
    submitForm() {
      if (!this.canRequest) {
        return;
      }
      if (this.formData.ReservationType * 1 !==  0) {
        if (!this.formData.Fee * 1 || this.formData.Fee * 1 === 0) {
          this.$util.errorMsg("请填写费用");
          return
        }
      }
      this.$refs.formData.validate(valid => {
        let that = this;
        if (valid) {
          that.loading = true;
          that.canRequest = false;
          that.$util
            .axiosPost({
              url: "/api/CustomerManagement/AddReservation",
              data: that.formData
            })
            .then(resp => {
              if (resp.errcode == 0) {
                that.$util.successMsg("添加成功");
                that.$emit("closeDialog", true);
              }
              setTimeout(() => {
                this.canRequest = true;
              }, 1000);
              that.loading = false;
            })
            .catch(() => {
              this.canRequest = true;
              that.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("closeDialog");
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-footer {
  text-align: right;
}
</style>
